import { ReactNode } from 'react';

interface ProjectFlowWithLink {
  name: string;
  isCompleted?: boolean;
  isDisabled?: boolean;
  disabledTooltipLabel?: ReactNode;
  isVisible: boolean;
  link: string;
  children?: never;
  type?: ProjectFlowType;
}

interface ProjectFlowWithChildren {
  name: string;
  isCompleted?: boolean;
  isDisabled?: boolean;
  disabledTooltipLabel?: ReactNode;
  isVisible: boolean;
  link?: never;
  children: ProjectFlowDto[];
  type?: ProjectFlowType;
}

export type ProjectFlowDto = ProjectFlowWithLink | ProjectFlowWithChildren;

export enum ProjectFlowType {
  IO = 'IO',
  IP = 'IP',
}
